import ShortenUrlSettingsTab from './shorten-url-settings';

export default ShortenUrlSettingsTab;
